import { Checkbox, FormControlLabel } from '@mui/material';
import Typography from '@mui/material/Typography';
import { isUndefined } from 'lodash';
import React, { Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import { locationPath } from '../../constants/app-routes';
import ErrorLabel from './ErrorLabel';

export default function CustomCheckBox(props) {
  const {
    name,
    label,
    error,
    onChange,
    required,
    errorsHandler,
    classNameLabel,
    className,
    item,
    labelPlacement,
    checked,
    disabled = false,
  } = props || {};
  const errorMessage = error?.[name];
  const hasError = !isUndefined(errorMessage);
  const history = useHistory();

  const errorRemovalHandler = () => {
    errorsHandler((prevError) => {
      delete prevError[name];
      return prevError;
    });
  };

  const handleLabelClick = (event, locationPath) => {
    event.stopPropagation();
    if (locationPath) {
      history.push(locationPath);
    }
  };

  return (
    <Fragment>
      <FormControlLabel
        control={
          <Checkbox
            className={` ${className}`}
            checked={checked}
            name={name}
            onChange={(event) => {
              onChange(event);
              hasError && errorRemovalHandler();
            }}
            color="primary"
            required={required}
          />
        }
        disabled={disabled}
        label={
          <Typography
            onClick={(e) => handleLabelClick(e, locationPath[item?.name])}
            className={classNameLabel}
          >
            {label}
          </Typography>
        }
        labelPlacement={labelPlacement || 'end'}
      />
      <ErrorLabel error={errorMessage} />
    </Fragment>
  );
}
